import { Language } from '../constants/languages';
export const MOBILE_DATE_PICKER_FORMAT = 'YYYY-MM-DD';
export const DATE_PICKER_TRANSLATION_KEYS = {
  defaultPlaceholder: 'component.DatePicker.desktop.accessibleCloseLabel',
  dateIsUnavailable: 'component.DatePicker.desktop.dateIsUnavailable',
  keyboardNavigationInstructions: 'component.DatePicker.desktop.keyboardNavigationInstructions',
  jumpToPrevMonth: 'component.DatePicker.desktop.jumpToPrevMonth',
  jumpToNextMonth: 'component.DatePicker.desktop.jumpToNextMonth',
  dateIsSelected: 'component.DatePicker.desktop.dateIsSelected',
  openCalendar: 'component.DatePicker.openCalendar',
  openMonthCalendar: 'component.DatePicker.openMonthCalendar',
  jumpToPrevYear: 'component.DatePicker.desktop.jumpToPrevYear',
  jumpToNextYear: 'component.DatePicker.desktop.jumpToNextYear',
  jumpToPrevYearRange: 'component.DatePicker.desktop.jumpToPrevYearRange',
  jumpToNextYearRange: 'component.DatePicker.desktop.jumpToNextYearRange'
};
export const DATE_PICKER_TRANSLATIONS = {
  [Language.EN]: {
    [DATE_PICKER_TRANSLATION_KEYS.defaultPlaceholder]: 'Date',
    [DATE_PICKER_TRANSLATION_KEYS.dateIsUnavailable]: _ref => {
      let {
        date
      } = _ref;
      return `${date} is not available`;
    },
    [DATE_PICKER_TRANSLATION_KEYS.keyboardNavigationInstructions]: 'Click arrow down to choose the date',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevMonth]: 'Go to previous month',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextMonth]: 'Go to next month',
    [DATE_PICKER_TRANSLATION_KEYS.dateIsSelected]: _ref2 => {
      let {
        date
      } = _ref2;
      return `You have chosen ${date}`;
    },
    [DATE_PICKER_TRANSLATION_KEYS.openCalendar]: 'Open calendar',
    [DATE_PICKER_TRANSLATION_KEYS.openMonthCalendar]: 'Open month calendar',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevYear]: 'Go to previous year',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextYear]: 'Go to next year',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevYearRange]: 'Go to previous years',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextYearRange]: 'Go to next years'
  },
  [Language.PL]: {
    [DATE_PICKER_TRANSLATION_KEYS.defaultPlaceholder]: 'Data',
    [DATE_PICKER_TRANSLATION_KEYS.dateIsUnavailable]: _ref3 => {
      let {
        date
      } = _ref3;
      return `${date} jest datą niedostępną`;
    },
    [DATE_PICKER_TRANSLATION_KEYS.keyboardNavigationInstructions]: 'Naciśnij strzałkę w dół, aby wybrać datę',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevMonth]: 'Przejdź do poprzedniego miesiąca',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextMonth]: 'Przejdź do następnego miesiąca',
    [DATE_PICKER_TRANSLATION_KEYS.dateIsSelected]: _ref4 => {
      let {
        date
      } = _ref4;
      return `Wybrałeś datę ${date}`;
    },
    [DATE_PICKER_TRANSLATION_KEYS.openCalendar]: 'Otwórz kalendarz',
    [DATE_PICKER_TRANSLATION_KEYS.openMonthCalendar]: 'Otwórz kalendarz miesięcy',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevYear]: 'Przejdź do poprzedniego roku',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextYear]: 'Przejdź do następnego roku',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevYearRange]: 'Przejdź do poprzedniego zakresu lat',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextYearRange]: 'Przejdź do następnego zakresu lat'
  },
  [Language.CS]: {
    [DATE_PICKER_TRANSLATION_KEYS.defaultPlaceholder]: 'Datum',
    [DATE_PICKER_TRANSLATION_KEYS.dateIsUnavailable]: _ref5 => {
      let {
        date
      } = _ref5;
      return `${date} není k dispozici`;
    },
    [DATE_PICKER_TRANSLATION_KEYS.keyboardNavigationInstructions]: 'Klikněte na šipku dolů pro výběr data',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevMonth]: 'Přejít na předchozí měsíc',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextMonth]: 'Přejít na příští měsíc',
    [DATE_PICKER_TRANSLATION_KEYS.dateIsSelected]: _ref6 => {
      let {
        date
      } = _ref6;
      return `Vybrali jste datum ${date}`;
    },
    [DATE_PICKER_TRANSLATION_KEYS.openCalendar]: 'Otevřít kalendář',
    [DATE_PICKER_TRANSLATION_KEYS.openMonthCalendar]: 'Otevřete kalendář měsíců',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevYear]: 'Přejít na předchozí rok',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextYear]: 'Přejít na další ročník',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevYearRange]: 'Přejít na rozsah předchozího roku',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextYearRange]: 'Přejděte do dalšího rozsahu let'
  },
  [Language.SK]: {
    [DATE_PICKER_TRANSLATION_KEYS.defaultPlaceholder]: 'Dátum',
    [DATE_PICKER_TRANSLATION_KEYS.dateIsUnavailable]: _ref7 => {
      let {
        date
      } = _ref7;
      return `${date} nie je k dispozícii`;
    },
    [DATE_PICKER_TRANSLATION_KEYS.keyboardNavigationInstructions]: 'Kliknite na šípku nadol pre výber dátumu',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevMonth]: 'Prejsť na predchádzajúci mesiac',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextMonth]: 'Prejsť na nasledujúci mesiac',
    [DATE_PICKER_TRANSLATION_KEYS.dateIsSelected]: _ref8 => {
      let {
        date
      } = _ref8;
      return `Vybrali ste dátum ${date}`;
    },
    [DATE_PICKER_TRANSLATION_KEYS.openCalendar]: 'Otvoriť kalendár',
    [DATE_PICKER_TRANSLATION_KEYS.openMonthCalendar]: 'Otvorte kalendár mesiacov',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevYear]: 'Prejsť na predchádzajúci rok',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextYear]: 'Choďte do ďalšieho ročníka',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToPrevYearRange]: 'Prejsť na rozsah predchádzajúceho roka',
    [DATE_PICKER_TRANSLATION_KEYS.jumpToNextYearRange]: 'Prejdite na ďalší rozsah rokov'
  }
};
export { TextFieldVariant as DatePickerVariant } from '../TextField/TextField.constants';